/**
 * Limits and identity rules for a form definition (the record around a form's
 * versions). The server's input schemas and the designer's own validation and
 * name generation read the same values, so a limit changes in one place.
 */

export const FORM_DEFINITION_LIMITS = {
    name: 200,
    description: 1000,
    schemaKey: 100,
    tag: 30,
    tags: 10,
    versionNotes: 500,
    archiveReason: 500,
} as const;

/** Lowercase alphanumeric with hyphens; also what `toSchemaKey` produces. */
export const SCHEMA_KEY_PATTERN = /^[a-z0-9-]+$/;

export const SCHEMA_KEY_PATTERN_MESSAGE = 'Schema key must be lowercase alphanumeric with hyphens';

/** The internal name a definition carries until an author names it. */
export const UNTITLED_FORM_NAME = 'Untitled form';

/** The schema key generated from an authored name. */
export function toSchemaKey(name: string): string {
    return name
        .toLowerCase()
        .replace(/\s+/g, '-')
        .replace(/[^a-z0-9-]/g, '')
        .replace(/-+/g, '-')
        .replace(/^-|-$/g, '')
        .slice(0, FORM_DEFINITION_LIMITS.schemaKey)
        .replace(/-$/g, '');
}

/** Keep respondent-facing titles intact while fitting internal definition names. */
export function toDefinitionName(title: string): string {
    return title.trim().slice(0, FORM_DEFINITION_LIMITS.name).trimEnd();
}
